import React from 'react';

const DeleteMyData = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#333' }}>
      <div style={{ textAlign: 'center', color: 'white', fontFamily: 'Arial, sans-serif' }}>
        <p>To delete your data, contact:</p>
        <p>Arush Srivastav: +91 9005549919</p>
        <p>Khushi Yadav: +91 8930097733 </p>
      </div>
    </div>
  );
};

export default DeleteMyData;
